// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__uM4iZ","title":"ClientReferral_title__3dGbq","itemText":"ClientReferral_itemText__3GssT"};